(()=>{
  if(window.__hrAtcStabilizer)return;
  window.__hrAtcStabilizer=1;

  const lang=(document.documentElement.lang||'').toLowerCase();
  const code=lang.startsWith('pt')?'pt':lang.slice(0,2);
  const labels={
    it:'AGGIUNGI AL CARRELLO',
    es:'AÑADIR AL CARRITO',
    de:'IN DEN WARENKORB',
    pt:'ADICIONAR AO CARRINHO'
  };
  const label=labels[code]||(window.variantStrings&&window.variantStrings.addToCart)||'ADD TO CART';

  if(window.variantStrings){
    window.variantStrings.addToCart=label;
  }

  const buttonSelector='button.product-form__submit[name="add"]';
  const spanSelector=buttonSelector+' > span:first-child';
  const soldRx=/^(?:sold out|esaurito|agotado|ausverkauft|esgotado|unavailable|non disponibile|no disponible|nicht verfügbar|indisponível)/i;
  const priceRx=/(?:[£€$¥]\s*\d[\d.,]*(?:\s*(?:GBP|EUR|USD|CAD|AUD|NZD|CHF|JPY))?|\d[\d.,]*\s*(?:[£€$¥])?(?:\s*(?:GBP|EUR|USD|CAD|AUD|NZD|CHF|JPY)))/gi;

  let applying=false;
  let queued=false;

  function cleanText(value){
    return String(value||'').replace(/\s+/g,' ').trim();
  }

  function fixSpan(span,baseOnly=false){
    if(!span)return;
    const button=span.closest(buttonSelector);
    if(!button)return;

    button.setAttribute('data-hr-no-translate','');

    const current=cleanText(span.textContent);
    if(button.disabled&&soldRx.test(current))return;

    const prices=current.match(priceRx)||[];
    const firstPrice=prices.length?cleanText(prices[0]):'';
    const desired=baseOnly?label:(label+(firstPrice?' - '+firstPrice:''));

    if(current!==desired){
      span.textContent=desired;
    }
  }

  function fixAll(baseOnly=false){
    document.querySelectorAll(spanSelector).forEach(span=>fixSpan(span,baseOnly));
  }

  function settle(){
    requestAnimationFrame(()=>requestAnimationFrame(()=>fixAll(false)));
    setTimeout(()=>fixAll(false),80);
    setTimeout(()=>fixAll(false),250);
    setTimeout(()=>fixAll(false),700);
  }

  document.addEventListener('change',event=>{
    const target=event.target;
    if(!target||!target.closest)return;
    if(target.closest('variant-selects,.product-form__input')){
      applying=true;
      fixAll(true);
      applying=false;
      settle();
    }
  },true);

  document.addEventListener('shopify:section:load',settle);

  function start(){
    applying=true;
    fixAll(false);
    applying=false;

    const observer=new MutationObserver(mutations=>{
      if(applying||queued)return;
      const relevant=mutations.some(mutation=>{
        const target=mutation.target&&mutation.target.nodeType===3?mutation.target.parentElement:mutation.target;
        if(target&&target.closest&&target.closest(buttonSelector))return true;
        return Array.from(mutation.addedNodes||[]).some(node=>{
          if(!node||node.nodeType!==1)return false;
          return (node.matches&&node.matches(buttonSelector))||(node.querySelector&&node.querySelector(buttonSelector));
        });
      });
      if(!relevant)return;
      queued=true;
      requestAnimationFrame(()=>{
        queued=false;
        applying=true;
        fixAll(false);
        applying=false;
      });
    });

    observer.observe(document.body,{subtree:true,childList:true,characterData:true});
    settle();
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',start,{once:true});
  }else{
    start();
  }
})();